import { createSelector } from 'reselect';
import { IReservationsState } from 'types/reservations.types';
import { IReservationsFormData } from 'views/public/ReservationsView/components/ReservationsForm/types';

const getItems = (state: { reservations: IReservationsState }) => state.reservations.items;
const getSelectedItem = (state: { reservations: IReservationsState }) =>
  state.reservations.selectedItem;
const getCementeries = (state: { reservations: IReservationsState }) =>
  state.reservations.cementeries;
const getCivilStates = (state: { reservations: IReservationsState }) =>
  state.reservations.civilStates;
const getIdCardTypes = (state: { reservations: IReservationsState }) =>
  state.reservations.idCardTypes;

export const reservationsSelector = createSelector([getItems], (reservations) => reservations);

export const reservationsFormSelector = createSelector(
  [getSelectedItem],
  (reservation): IReservationsFormData => ({
    person: {
      id: reservation?.person?.id || 0,
      name: reservation?.person?.name || '',
      lastName: reservation?.person?.lastName || '',
      idCardType: reservation?.person?.idCardType,
      idCard: reservation?.person?.idCard || '',
      address: reservation?.person?.address || '',
      age: reservation?.person?.age || '',
      areaCode: reservation?.person?.areaCode || '',
      phone: reservation?.person?.phone || '',
      community: reservation?.person?.community || '',
      civilState: reservation?.person?.civilState || '',
      weddingTemple: reservation?.person?.weddingTemple || '',
    },
    family: {
      id: reservation?.family?.id || 0,
      spouseInfo: reservation?.family?.spouseInfo || '',
      fatherInfo: reservation?.family?.fatherInfo || '',
      motherInfo: reservation?.family?.motherInfo || '',
      childrenInfo: reservation?.family?.childrenInfo || '',
    },
    location: {
      id: reservation?.location?.id || 0,
      cementery: reservation?.location?.cementery || '',
      plot: reservation?.location?.plot || '',
    },
    manager: {
      id: reservation?.manager?.id || 0,
      name: reservation?.manager?.name || '',
      idCardType: reservation?.manager?.idCardType,
      idCard: reservation?.manager?.idCard || '',
      address: reservation?.manager?.address || '',
      areaCode: reservation?.manager?.areaCode || '',
      phone: reservation?.manager?.phone || '',
      relationship: reservation?.manager?.relationship || '',
    },
    payment: {
      id: reservation?.payment?.id || 0,
      currency: reservation?.payment?.currency || '',
      amount: reservation?.payment?.amount || '',
      paymentMethod: reservation?.payment?.paymentMethod || '',
    },
    comments: reservation?.comments || '',
  }),
);

export const reservationsCementeriesSelector = createSelector([getCementeries], (cementeries) =>
  Object.keys(cementeries).map((key) => ({
    label: cementeries[key],
    value: key,
  })),
);

export const reservationsCivilStatesSelector = createSelector([getCivilStates], (civilStates) =>
  Object.keys(civilStates).map((key) => ({
    label: civilStates[key],
    value: key,
  })),
);

export const reservationsIdCardTypesSelector = createSelector([getIdCardTypes], (idCardTypes) =>
  Object.keys(idCardTypes).map((key) => ({
    label: idCardTypes[key],
    value: key,
  })),
);

export const reservationsFilesSelector = createSelector([getSelectedItem], (reservation) => ({
  personIdCardFile: reservation?.person?.idCardFile || '',
  personIdCardBackFile: reservation?.person?.idCardBackFile || '',
  personKetubaFile: reservation?.person?.ketubaFile || '',
  personMarriageCertificateFile: reservation?.person?.marriageCertificateFile || '',
  personGetFile: reservation?.person?.getFile || '',
  managerIdCardFile: reservation?.manager?.idCardFile || '',
  managerIdCardBackFile: reservation?.manager?.idCardBackFile || '',
}));
